module.exports = __webpack_public_path__ + "static/img/topsupport.15ae4eb0.png";